import { ItemType } from '@game/enums';
import type { ModuleSlots, PopulatedItem } from '@game/game-data';
import type { ClientModuleItem } from '@game/shared-types';

export function getModuleSlots(item: PopulatedItem): ModuleSlots {
  return item.type === ItemType.Equipment ? item.moduleSlots : 0;
}

export function getModules(item: PopulatedItem): ClientModuleItem[] {
  return item.type === ItemType.Equipment ? item.modules : [];
}
